module.exports = __webpack_public_path__ + "static/img/30006 (4).62d9bca.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30006 (4).webp
// module id = bTju
// module chunks = 14